/**
 * 事件详情
 */
angular.module("featureUsageStatisticsEventModule", []).
controller("featureUsageStatisticsEventCtrl", ["$scope", "featureUsageStatisticsService", "$element", "$filter", "globleParamsSet", "trsHttpService", "$q", '$state',
    function($scope, featureUsageStatisticsService, $element, $filter, globleParamsSet, trsHttpService, $q, $state) {
        initStatus();
        initData();
        /**
         * [getTenants description] 获取租户列表
         * @return {[type]} [description]
         */
        function getTenants() {
            let deffer = $q.defer();
            let params = {
                serviceid: "mlf_buridecode",
                methodname: "gettenant"
            };
            $scope.loadingPromise = featureUsageStatisticsService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(resp => {
                resp.data.forEach(item => {
                    item.name = item.tenantname;
                });
                $scope.data.tenants = $scope.data.tenants.concat(resp.data);
                $scope.status.selectedTenant = angular.copy($scope.data.tenants.filter(item => {
                    return item.tenantid == $state.params.tenantid;
                })[0]);
                $scope.status.selectedTenant = $scope.status.selectedTenant ? $scope.status.selectedTenant : angular.copy($scope.data.tenants[0]);
                deffer.resolve();
            });
            return deffer.promise;
        }
        $scope.selectTenant = function() {
            requestData();
        };
        /**
         * [back description] 返回
         * @return {[type]} [description]
         */
        $scope.back = function() {
            $state.go("manageconfig.logmanage.featureusagestatistics", { tenantid: $state.params.tenantid }, { reload: false });
        };
        /**
         * [requestData description] 获取事件明细
         * @return {[type]} [description]
         */
        function requestData() {
            let deffer = $q.defer();
            setEcharts()
            $scope.loadingPromise = featureUsageStatisticsService.httpServer(trsHttpService.getWCMRootUrl(), handleParams(), "get").then(resp => {
                $scope.data.items = resp.data.content;
                handlPage(resp.data);
                deffer.resolve();
            });
            return deffer.promise;
        }
        /**
         * [constructDateArray description] 构造日期数组
         * @return {[type]} [description]
         */
        function constructDateArray() {
            let array = [];
            for (let i = 1; i <= 24; i++) {
                array.push(i);
            }
            return array;
        }
        /**
         * [getChartsData description] 获取图表数据
         * @return {[type]} [description]
         */
        function getChartsData() {
            let deffer = $q.defer();
            let params = {
                serviceid: "mlf_buridecode",
                methodname: "querytimestat",
                startdate: $scope.status.fromdate + " 00:00:00",
                enddate: $scope.status.untildate + " 23:59:59",
                statid: $state.params.eventid,
                tenantid: $scope.status.selectedTenant.tenantid
            };
            $scope.loadingPromise = featureUsageStatisticsService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(resp => {
                $scope.data.chartsData.UV = constructData("UV", resp);
                $scope.data.chartsData.PV = constructData("PV", resp);
                deffer.resolve();
            });
            /**
             * [constructData description] 构造数据
             * @param  {[type]} name [description]
             * @return {[type]}      [description]
             */
            function constructData(name, resp) {
                //直接将object转换为数组，顺序混乱，需要做特殊处理，故而代码复杂
                let array = [];
                let data = resp.data[name][0];
                for (let i in data) {
                    array.push({ value: data[i], key: i });
                }
                array.sort((x, y) => {
                    let keyX = Number(x.key.replace(/t/, "").replace(/u/, ""));
                    let keyY = Number(y.key.replace(/t/, "").replace(/u/, ""));
                    return keyX - keyY;
                });
                array.forEach((item, index) => {
                    array[index] = item.value;
                });
                return array;
            }
            return deffer.promise;
        }
        /**
         * [setEcharts description] 绘制echarts图表
         */
        function setEcharts() {
            require(['echarts'], function(echarts) {
                getChartsData().then(() => {
                    let options = {
                        title: {
                            text: '事件趋势',
                            left: "20px"
                        },
                        tooltip: {
                            trigger: 'axis',
                            formatter(params) {
                                console.log(params);
                                let toolTip = [];
                                for (let i = 0; i < params.length; i++) {
                                    toolTip.push(constructToolTip(params[i]));
                                }

                                function constructToolTip(data) {
                                    return `${data.seriesName}: ${data.data}`;
                                }
                                toolTip = toolTip.join("<br/>");
                                return toolTip
                            }
                        },
                        legend: {
                            data: [{
                                name: "操作次数",
                                icon: "path://m",
                                textStyle: {
                                    backgroundColor: "#5CC668",
                                }
                            }, {
                                name: "独立访客",
                                icon: "path://m",
                                textStyle: {
                                    backgroundColor: "#3080FF",
                                },
                            }],
                            right: "30px",
                            textStyle: {
                                padding: 6,
                                borderRadius: 2,
                                color: "white",
                            }
                        },
                        grid: {
                            left: '2%',
                            right: '4%',
                            bottom: '0%',
                            containLabel: true
                        },
                        xAxis: {
                            name: "时间",
                            type: 'category',
                            boundaryGap: false,
                            data: constructDateArray()
                        },
                        yAxis: {
                            name: "次数",
                            type: 'value'
                        },
                        series: [{
                                name: '操作次数',
                                type: 'line',
                                data: $scope.data.chartsData.PV,
                                lineStyle: {
                                    color: "#5CC668"
                                }
                            },
                            {
                                name: '独立访客',
                                type: 'line',
                                data: $scope.data.chartsData.UV,
                                lineStyle: {
                                    color: "#3080FF"
                                }
                            }
                        ]
                    };
                    echarts = echarts.init($element.find(".main")[0]);
                    echarts.setOption(options);
                });
            });
        }
        $scope.selectDate = requestData;
        /**
         * [handlPage description] 处理分页参数
         * @return {[type]} [description]
         */
        function handlPage(data) {
            $scope.page = {
                CURRPAGE: data.number + 1,
                ITEMCOUNT: data.totalElements,
                PAGESIZE: data.size,
                PAGECOUNT: data.totalPages
            }
            $scope.status.copyCurrPage = data.number + 1;
        }
        /**
         * [selectPageNum description] 选择每页大小
         * @return {[type]} [description]
         */
        $scope.selectPageNum = requestData;
        /**
         * [pageChanged description] 选页数
         * @return {[type]} [description]
         */
        $scope.pageChanged = requestData;
        /**
         * [jumpToPage description] 指定跳转到某一页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };
        /**
         * [fullTextSearch description] 关键词搜索
         * @return {[type]} [description]
         */
        $scope.fullTextSearch = function($event) {
            if ($event && $event.keyCode != 13) return;
            $scope.status.isSearch = $scope.status.keywords == "" ? false : true;
            requestData();
        }
        /**
         * [handleParams description] 处理参数
         * @return {[type]} [description]
         */
        function handleParams() {
            let params = {
                tenantid: $scope.status.selectedTenant.tenantid,
                statid: $state.params.eventid,
                serviceid: "mlf_buridecode",
                methodname: "requestdetail",
                startdate: "",
                enddate: ""
            };
            if ($scope.status.isSearch) {
                params.keyword = $scope.status.keywords;
            }
            if ($scope.status.untildate) {
                params.startdate = $scope.status.fromdate + " 00:00:00";
                params.enddate = $scope.status.untildate + " 23:59:59";
            }
            params.startPage = $scope.page.CURRPAGE - 1;
            params.pageSize = $scope.page.PAGESIZE;
            return params;
        }
        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            let date = $state.params.date,
                fromdate, untildate;
            if (date) {
                fromdate = date.split(",")[0];
                untildate = date.split(",")[1];
            }
            $scope.status = {
                fromdate: (() => {
                    if (fromdate) return fromdate;
                    let date = new Date();
                    date.setMonth(date.getMonth() - 1);
                    date = $filter("date")(date, "yyyy-MM-dd");
                    return date;
                })(),
                untildate: (() => {
                    if (untildate) return untildate;
                    let date = new Date();
                    return $filter("date")(date, "yyyy-MM-dd");
                })(),
                title: $state.params.title
            };
            $scope.data = {
                tenants: [{
                    name: "全部租户",
                }],
                chartsData: {}
            };
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": globleParamsSet.getPageSize(),
                "ITEMCOUNT": 0,
                "PAGECOUNT": 1
            };
        }
        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            getTenants().then(() => {
                requestData();
            });
        }
    }
]);